<div class="app-container !p-0">
  <div class="p-4 bg-white">
    <div class="container mx-auto flex gap-5  justify-between items-center">

      <div class="ml-auto">
        <app-button (click)="onCreateNewUserClicked()">Create New User</app-button>
      </div>
    </div>
  </div>

  <div class="app-page-content grow overflow-auto">
    <app-data-table
      [enableSearch]="true"
      [columnDefs]="columnDefs"
      [state]="getAdminUsersState"
      (onActionPerformed)="onActionClicked($event)"
      (tableStateChanged)="getAdminUserList($event)"
    >
    </app-data-table>
  </div>
</div>
